import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-driver-signup',
    templateUrl: './driver-signup.component.html',
    styleUrls: ['./driver-signup.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DriverSignupComponent {

}
